import { useEffect } from 'react'
import { dispatch } from 'store'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import AiAvatarTitle from './components/AiAvatarTitle'
import AvatarSection from './sections/AvatarSection'
import VoiceSection from './sections/VoiceSection'
import SpeechSection from './sections/SpeechSection'
import QualitySection from './sections/QualitySection'
import GenerateFooter from './GenerateFooter'
import * as Styled from './styled'

const AiAvatarContent: React.FC = () => {
  // The tab content mounts only while the AI Avatar tab is active, so this runs
  // on tab open. The thunk caches its result, so re-opening won't refetch.
  useEffect(() => {
    dispatch(aiAvatarThunks.getPublicAvatars())
    dispatch(aiAvatarThunks.getAvatarModels())
    // Free-trial eligibility for the generate footer (self-guards to free users).
    dispatch(aiAvatarThunks.checkGiftAccess())
    // A source-image Enhance/Resize kicked off before a reload: reseed the form
    // from localStorage and reconcile with the backend (self-guards — a no-op
    // unless a valid persisted op exists and the form is fresh and empty).
    dispatch(aiAvatarThunks.restorePendingSourceImage())
  }, [])

  return (
    <Styled.AiAvatarTabWrapper data-role="ai-avatar-tab-content">
      <Styled.ScrollableContent>
        <AiAvatarTitle />
        <AvatarSection />
        <VoiceSection />
        <SpeechSection />
        <QualitySection />
      </Styled.ScrollableContent>
      <GenerateFooter />
    </Styled.AiAvatarTabWrapper>
  )
}

export default AiAvatarContent
